import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import MaterialTableHead from '@material-ui/core/TableHead';
import ReportConversionContext from '@/modules/reports/contexts/ReportConversionContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';
import { humanizeConversion } from '~/common';
import CellPrimary from './CellPrimary';

function getAvgConversion(report) {
    let count = 0;
    let conversion = 0;
    Object.entries(report).forEach(([, value]) => {
        count += 1;
        // noinspection JSUnresolvedVariable
        conversion += value.conversion;
    });
    return conversion / count;
}

const TableHead = (props) => {
    // noinspection JSUnresolvedFunction
    const reportConversionContext = useContext(ReportConversionContext);

    return (
        <MaterialTableHead>
            <TableRow>
                <CellPrimary/>
                <TableCellOrder className="total" orderName="total"
                                ordering={reportConversionContext.ordering}
                                onClick={reportConversionContext.handleClickOrder}>
                    Тотал
                </TableCellOrder>
                <TableCellOrder className="avg" orderName="avg"
                                ordering={reportConversionContext.ordering}
                                onClick={reportConversionContext.handleClickOrder}
                >
                    {humanizeConversion(getAvgConversion(props.report))}
                </TableCellOrder>
            </TableRow>
        </MaterialTableHead>
    );
};

TableHead.propTypes = {
    report: PropTypes.object.isRequired,
};

export default TableHead;
